import { makeLabels } from 'utils/i18n';

export const KEYS = {
  NEW_ITEM_PREFIX: 'new_item_',
  CUSTOM_ITEM_FORM_FIELDS: {
    NAME: 'name',
    FIAT_AMOUNT: 'fiatAmount',
  },
} as const;

export type CustomItemFormField = (typeof KEYS.CUSTOM_ITEM_FORM_FIELDS)[keyof typeof KEYS.CUSTOM_ITEM_FORM_FIELDS];
export type CustomItemFormValues = {
  [KEYS.CUSTOM_ITEM_FORM_FIELDS.NAME]: string | undefined;
  [KEYS.CUSTOM_ITEM_FORM_FIELDS.FIAT_AMOUNT]: number | undefined;
};

export const NAMESPACE = 'page.pwcOrders.view.sections.order.refund.customItemForm';
export const LABELS = makeLabels(
  {
    FIELDS: {
      [KEYS.CUSTOM_ITEM_FORM_FIELDS.NAME]: ['fields.name', 'Product/Service'],
      [KEYS.CUSTOM_ITEM_FORM_FIELDS.FIAT_AMOUNT]: ['fields.fiatAmount', 'Amount'],
    },
    ERRORS: {
      [KEYS.CUSTOM_ITEM_FORM_FIELDS.NAME]: ['errors.name', 'Please enter a product/service name'],
      [KEYS.CUSTOM_ITEM_FORM_FIELDS.FIAT_AMOUNT]: ['errors.fiatAmount', 'Please enter a valid amount'],
    },
    ACTIONS: {
      CANCEL: ['actions.cancel', 'Cancel'],
      ADD: ['actions.add', 'Add'],
    },
    PLACEHOLDERS: {
      [KEYS.CUSTOM_ITEM_FORM_FIELDS.NAME]: ['placeholders.name', 'Enter Item Name'],
    },
  },
  NAMESPACE,
);
